import {Injectable} from '@angular/core';
import {GenericHandler} from '../generics/generic-handler';
import {FormFieldBaseSupplier} from '../../suppliers/form-fieldbase-supplier';
import {DialogMsgSupplier} from '../../suppliers/dialog-msg-supplier';
import {StockDTO} from '../../dtos/stock-dto';
import {UtilsService} from '../../utils/utils.service';
import {Auth2Service} from '../security/auth2.service';
import {Router} from '@angular/router';
import {HttpClient, HttpHeaders, HttpParams, HttpResponse} from '@angular/common/http';
import {Title} from '@angular/platform-browser';
import {UniteDeProduction__zoneDeStockageService} from '../entities/unite-de-production__zone-de-stockage.service';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import * as moment from 'moment';
import {ModelViewInventaire} from '../../../gestion-stocks/stocks/inventaire/model-view-inventaire';
import {InventaireFilters} from '../../models/gestion-stock/inventaire-filters.model';
import {FormFieldDropdownSupplier} from '../../suppliers/form-field-dropdown-supplier';
import {UniteDeProduction__ZoneDeStockageDTO} from '../../dtos/unite-de-production__zone-stockage-dto';
import {FormFieldCurrencySupplier} from "../../suppliers/form-field-currency-supplier";
import {FormFieldCalendarSupplier} from "../../suppliers/form-field-calendar-supplier";
import {HttpService} from "../technique/http.service";
import {URL_POST_DELETE_LOTS} from "../entities/produit-declinaison.service";
import {ResponseWrapper} from "../../suppliers/wrappers/response-wrapper";
import {StockAlerteSite} from "../../models/gestion-stock/stock-alerte-site.model";
import {StockAlerte} from "../../models/gestion-stock/stock-alerte.model";
import {HistoriqueInventaireConflitDto} from "../../dtos/historique-inventaire-conflit-dto";

export const URL_GET_SITES_DISPO_INVENTAIRE = `dolrest/gestion-stocks/sites-disponibles-inventaire`;
export const URL_GET_HISTORIQUES_INVENTAIRE = `dolrest/gestion-stocks/historiques-inventaire`;
export const URL_GET_VALIDATIONS_INVENTAIRE = `dolrest/gestion-stocks/validation-inventaire`;
export const URL_GET_AVAILABLE_INVENTAIRE_HISTORY = `dolrest/gestion-stocks/validation-inventaire/available`;
export const URL_POST_SAVE_VALIDATION_INVENTAIRE = `dolrest/gestion-stocks/validation-inventaire/save`;
export const URL_PUT_APPROUVE_INVENTAIRE = `dolrest/gestion-stocks/validation-inventaire/approuve`;
export const URL_PUT_INVALIDE_INVENTAIRE = `dolrest/gestion-stocks/validation-inventaire/invalide`;
export const URL_PUT_UPDATE_INFO_ANNEXE_VALIDATION_INVENTAIRE = `dolrest/gestion-stocks/validation-inventaire/info-annexe`;
export const URL_EXPORT_HISTORIQUE_INVENTAIRE = `dolrest/gestion-stocks/export/historique-inventaire`;
export const URL_POST_SAVE_HISTORIQUE_INVENTAIRE = `dolrest/gestion-stocks/save/historique-inventaire`;
export const URL_GET_CONFLITS_HISTORIQUE_INVENTAIRE = `dolrest/gestion-stocks/conflits-historique-inventaire`;
export const URL_GET_PREPARE_SEARCH = `dolrest/gestion-stocks/prepare-search`;
export const URL_POST_SAVE_INVENTAIRE = `dolrest/gestion-stocks/save/inventaire`;
export const URL_POST_SAVE_STOCK = `dolrest/gestion-stocks/ajout/lot`;
export const URL_POST_UPDATE_STOCK = `dolrest/gestion-stocks/update/lot`;
export const URL_GET_SITE_STOCK_MINI_LIST = `dolrest/gestion-stocks/site-list-with-stock-alerte`;
export const URL_GET_STOCK_ALERTE_BY_SITE = `dolrest/gestion-stocks/stock-alerte`;
export const URL_UPDATE_STOCK_ALERTE = `dolrest/gestion-stocks/update-stock-alerte`;
export const URL_UPDATE_STOCK_ALERTE_QUANTITY = `dolrest/gestion-stocks/quantity-stock-alerte`;
export const URL_DELETE_STOCK_ALERTE = `dolrest/gestion-stocks/stock-alerte`;
export const URL_GET_STOCK_ALERTE_QUANTITY = `dolrest/gestion-stocks/stock-alerte-quantity`;
export const URL_DELETE_HISTORIQUE_INVENTAIRE = `dolrest/gestion-stocks/historiques-inventaire`;
export const URL_DELETE_VALIDATION_INVENTAIRE = `dolrest/gestion-stocks/validation-inventaire`;

@Injectable({
  providedIn: 'root'
})
export class StocksService extends GenericHandler<StockDTO> {

  stockAlerteQuantity: number;

  private subjectFeature = new Subject<{ feature: string; page: number; size: number }>();
  public feature$: Observable<{ feature: string; page: number; size: number }> = this.subjectFeature.asObservable();

  private subjectUpdateStockAlertQuantity = new Subject<any>();
  public updateStockAlertQuantity$: Observable<void> = this.subjectUpdateStockAlertQuantity.asObservable();

  private subjectLoadStocks = new Subject<ModelViewInventaire>();
  public loadStocks$: Observable<ModelViewInventaire> = this.subjectLoadStocks.asObservable();

  private subjectRefreshMatieresPremieresAndStocks = new Subject<number>();
  public loadMatieresPremieresAndStocks$: Observable<number> = this.subjectRefreshMatieresPremieresAndStocks.asObservable();

  private subjectOpenDialogSortie = new Subject<DialogStockSortieSupplier>();
  public openDialogSortie$: Observable<DialogStockSortieSupplier> = this.subjectOpenDialogSortie.asObservable();

  private subjectIsKeepItClose = new Subject<boolean>();
  public isKeepItClose$: Observable<boolean> = this.subjectIsKeepItClose.asObservable();

  private subjectIsConfirmCancelled = new Subject<boolean>();
  public isConfirmCancelled$: Observable<boolean> = this.subjectIsConfirmCancelled.asObservable();

  private subjectOpenDialogEditLot = new Subject<DialogStockSortieSupplier>();
  public openDialogEditLot$: Observable<DialogStockSortieSupplier> = this.subjectOpenDialogEditLot.asObservable();

  private subjectLotsDeleted = new Subject();
  lotsDeleted$ = this.subjectLotsDeleted.asObservable();

  private subjectOpenDialogPerimes = new Subject();
  openDialogPerimes$ = this.subjectOpenDialogPerimes.asObservable();

  private subjectTriggerPrint = new Subject<boolean>();
  public triggerPrint$ = this.subjectTriggerPrint.asObservable();

  private subjectTriggerExportHistorique = new Subject<void>();
  public triggerExportHistorique$ = this.subjectTriggerExportHistorique.asObservable();

  private subjectWaitingForHistoryParams = new Subject<boolean>();
  public waitingForHistoryParams$ = this.subjectWaitingForHistoryParams.asObservable();

  private subjectInventaireLoading = new Subject<boolean>();
  public inventaireLoading$ = this.subjectInventaireLoading.asObservable();

  private inventaireDateSubject = new BehaviorSubject<Date | null>(null);
  public inventaireDate$ = this.inventaireDateSubject.asObservable();

  constructor(utils: UtilsService, private udpZdsSvc: UniteDeProduction__zoneDeStockageService,
              auth2Svc: Auth2Service, router: Router, http: HttpClient, title: Title, private httpSvc: HttpService) {
    super(utils, auth2Svc, router, http, title);


  }

  announceClickPrint() {
    this.subjectTriggerPrint.next();
  }

  announceExportHistorique() {
    this.subjectTriggerExportHistorique.next();
  }

  announceWaitingForHistoryParams = (waiting: boolean): void => {
    this.subjectWaitingForHistoryParams.next(waiting);
  };

  announceInventaireLoading = (loading: boolean): void => {
    this.subjectInventaireLoading.next(loading);
  };

  announceInventaireDate = (date: Date | null): void => {
    this.inventaireDateSubject.next(date);
  };

  announceLotsDeleted = () => {
    this.subjectLotsDeleted.next();
  };

  announceOpenDialogPerimes = () => {
    this.subjectOpenDialogPerimes.next();
  };

  updateLotsPerimes = (dateUntilWhichLotsPerimes: Date, idsUdp: number[]) => {
    const body = {
      udpIdList: idsUdp,
      dateUntilWhichLotsPerimes: dateUntilWhichLotsPerimes,
    }
    return this.httpSvc.post(`${URL_POST_DELETE_LOTS}`, body);
  }

  createEmptyDTO = (): StockDTO => undefined;

  getAllFromEnvironnement = (): void => {
  };

  getCreateNewObjectLabel = (): string => '';

  getEditObjectLabel = (data: StockDTO): string => '';

  getEntityName = (): string => 'stock';

  getFields = (dto: any): FormFieldBaseSupplier<any>[] => {
    if (!dto) {
      return [];
    }
    const udpZdsList = this.initUdpZdsList(dto.idUdp);
    const udpZdsSelected = udpZdsList.find(udpZds => udpZds.id === dto.idUdpZoneDeStockage);
    const fields: FormFieldBaseSupplier<any>[] = [
      new FormFieldDropdownSupplier({
        key: 'unitesProductionZonesDeProduction',
        label: 'Zone de stockage',
        optionLabel: 'libelleZoneDeStockage',
        readonly: !this.canModify(dto),
        type: 'singleListBox',
        value: this.utils.preSelectSingleList(udpZdsList, udpZdsSelected),
        order: 1,
        options: udpZdsList,
        width: 300,
        required: true,
      }),

      new FormFieldCurrencySupplier({
        key: 'quantite',
        label: 'Quantité',
        width: 150,
        type: 'number',
        suffix: dto.udmStockLibelle,
        value: dto.quantite,
        required: true,
        order: 2
      }),

      new FormFieldCurrencySupplier({
        key: 'prixUnitaire',
        label: 'PU H.T en UF',
        width: 150,
        type: 'number',
        suffix: '€/' + (dto.udmFacturationLibelle ? dto.udmFacturationLibelle : dto.uniteFacturation),
        value: dto.prixUnitaire,
        required: true,
        order: 3
      }),

      new FormFieldCalendarSupplier({
        key: 'dateEntree',
        label: 'Date Entrée',
        value: new Date(dto.dateEntree),
        dateFormat: 'dd/mm/yy',
        required: true,
        showTime: false,
        order: 4
      })

    ];
    return fields;
  };

  initUdpZdsList = (idUdp: number): UniteDeProduction__ZoneDeStockageDTO[] => {
    const udpZdsList = this.udpZdsSvc.udpZdsListEnvironnement;
    if (this.utils.isCollectionNullOrEmpty(udpZdsList)) {
      return [];
    }
    return udpZdsList.filter(item => item.idUniteDeProduction === idUdp);
  };

  getHelp = (): DialogMsgSupplier => undefined;

  getOas = (): boolean => false;

  getSort = (): string[] => [];

  getTitle = (): string => 'GESTION DES STOCKS';

  getTotalRecordsLabel = (): string => '';

  prepareSearch = (idsSites: number[]) => {
    let args: string = '';
    if (idsSites && idsSites.length) args += `&idsSites=${idsSites}`;
    return this.httpSvc.get(`${URL_GET_PREPARE_SEARCH}?1=1${args}`);
  };


  announceFeature = (feature: string, page: number, size: number) => {
    this.subjectFeature.next({feature, page, size});
  };

  public announceOpenDialogEditLot = (selectedMatierePremiere: ModelViewInventaire, stockDTO: ModelViewInventaire) => {
    this.subjectOpenDialogEditLot.next(new DialogStockSortieSupplier(stockDTO, null, selectedMatierePremiere));
  };


  saveInventaire = (lignesInventaire: ModelViewInventaire[]) => {
    return this.httpSvc.post(URL_POST_SAVE_INVENTAIRE, lignesInventaire);
  };

  saveStock = (stock: StockDTO) => {
    return this.httpSvc.post(URL_POST_SAVE_STOCK, stock);
  };

  updateStock = (stock: StockDTO) => {
    return this.httpSvc.post(URL_POST_UPDATE_STOCK, stock);
  };

  updateQteLotsInventaire = (view: ModelViewInventaire, qteAjustee: number) => {
    return this.httpSvc.post(`dolrest/gestion-stocks/update/lots/quantities?qteAjustee=${qteAjustee}`, view);
  }


  announceOpenDialogSortie = (filters: InventaireFilters, selectedStock: ModelViewInventaire, matierePremiere: ModelViewInventaire) => {
    const dsss = new DialogStockSortieSupplier(selectedStock, filters, matierePremiere);
    this.subjectOpenDialogSortie.next(dsss);
  };

  announceLoadStocks = (matierePremiere: ModelViewInventaire) => {
    this.subjectLoadStocks.next(matierePremiere);
  };

  announceRefreshStocks = (idParent: number) => {
    this.subjectRefreshMatieresPremieresAndStocks.next(idParent);
  };

  /**
   * si champ de recherhce 'Périmé le ' renseigné, on prend cette date
   * sinon on prend la date du jour pour considerer que le stock est périmé
   * @param dlc
   * @param filters
   */
  isPerime = (dlc: Date, filters: InventaireFilters) => {
    const datePerime = filters?.datePeremption ? moment(filters.datePeremption) : moment();
    return moment(dlc).isBefore(datePerime, 'day');
  };

  getSiteStockMini(): Observable<ResponseWrapper<StockAlerteSite>> {
    return this.httpSvc.get(URL_GET_SITE_STOCK_MINI_LIST);
  }

  getStockAlerteBySite(idSite: number): Observable<ResponseWrapper<StockAlerte>> {
    return this.httpSvc.get(`${URL_GET_STOCK_ALERTE_BY_SITE}/${idSite}`);
  }

  updateStockAlerte(selectedSite: number) {
    return this.httpSvc.get(`${URL_UPDATE_STOCK_ALERTE}/${selectedSite}`);
  }

  updateAllStockAlerte(selectedSite: number) {
    this.httpSvc.get(`${URL_UPDATE_STOCK_ALERTE_QUANTITY}/${selectedSite}`).subscribe((res) => {
      this.stockAlerteQuantity = res;
    });
  }

  deleteStockAlerte(selectedStockAlerteList: number[]): Observable<any> {
    const params: HttpParams = new HttpParams().set("idStockAlertes", selectedStockAlerteList.join(','));
    return this.httpSvc.delete(`${URL_DELETE_STOCK_ALERTE}`, params);
  }

  getStockAlerteQuantity(): Observable<ResponseWrapper<number>> {
    return this.httpSvc.get(`${URL_GET_STOCK_ALERTE_QUANTITY}`);
  }

  announceUpdateStockAlertQuantity() {
    this.subjectUpdateStockAlertQuantity.next();
  }

  getSitesDisponiblesInventaire(): Observable<ResponseWrapper<SiteInventaireDisponible>> {
    return this.httpSvc.get(URL_GET_SITES_DISPO_INVENTAIRE);
  }

  getConflitsHistoriqueInventaire(idSite: number, histoDate: Date): Observable<ResponseWrapper<HistoriqueInventaireConflitDto>> {
    return this.httpSvc.get(`${URL_GET_CONFLITS_HISTORIQUE_INVENTAIRE}?idSite=${idSite}&histoDate=${this.utils.formatDate(histoDate)}`);
  }

  saveHistoriqueInventaire(idSite: number, dateInventaire: Date, typeAlimentaire?: Boolean): Observable<ResponseWrapper<any>> {
    let params = `idSite=${idSite}&dateInventaire=${this.utils.formatDate(dateInventaire)}`;
    if (typeAlimentaire != null) params += `&typeAlimentaire=${typeAlimentaire}`;
    return this.httpSvc.post(`${URL_POST_SAVE_HISTORIQUE_INVENTAIRE}?${params}`, null);
  }

  getHistoriquesInventaire(): Observable<ResponseWrapper<any>> {
    return this.httpSvc.get(URL_GET_HISTORIQUES_INVENTAIRE);
  }

  deleteHistoriqueInventaire(idList: number[]): Observable<ResponseWrapper<any>> {
    const params: HttpParams = new HttpParams().set('idList', idList.join(','));
    return this.httpSvc.delete(URL_DELETE_HISTORIQUE_INVENTAIRE, params);
  }

  getValidationsInventaire(): Observable<ResponseWrapper<any>> {
    return this.httpSvc.get(URL_GET_VALIDATIONS_INVENTAIRE);
  }

  getAvailableInventaireHistory(): Observable<ResponseWrapper<any>> {
    return this.httpSvc.get(URL_GET_AVAILABLE_INVENTAIRE_HISTORY);
  }

  saveValidationInventaire(inventaireHistoryId: number): Observable<ResponseWrapper<any>> {
    return this.httpSvc.post(`${URL_POST_SAVE_VALIDATION_INVENTAIRE}?inventaireHistoryId=${inventaireHistoryId}`, null);
  }

  approuveInventaire(inventaireHistoryIdList: number[]): Observable<ResponseWrapper<any>> {
    return this.httpSvc.put(URL_PUT_APPROUVE_INVENTAIRE, inventaireHistoryIdList);
  }

  invalideInventaire(inventaireHistoryIdList: number[]): Observable<ResponseWrapper<any>> {
    return this.httpSvc.put(URL_PUT_INVALIDE_INVENTAIRE, inventaireHistoryIdList);
  }

  updateInfoAnnexeValidationInventaire(inventaireHistoryId: number, infoAnnexe: string): Observable<ResponseWrapper<any>> {
    return this.httpSvc.put(`${URL_PUT_UPDATE_INFO_ANNEXE_VALIDATION_INVENTAIRE}?inventaireHistoryId=${inventaireHistoryId}`, infoAnnexe);
  }

  deleteValidationInventaire(idList: number[]): Observable<ResponseWrapper<any>> {
    const params: HttpParams = new HttpParams().set('idList', idList.join(','));
    return this.httpSvc.delete(URL_DELETE_VALIDATION_INVENTAIRE, params);
  }

  exportHistoriqueInventaire(idList: number[]): Observable<HttpResponse<Blob>> {
    const params = `idList=${idList}`;
    return this.http.get(`${URL_EXPORT_HISTORIQUE_INVENTAIRE}?${params}`, {
      responseType: 'blob',
      observe: 'response',
      headers: new HttpHeaders().set('Accept', 'application/octet-stream')
    });
  }
}

export class DialogStockSortieSupplier {

  selectedStock: ModelViewInventaire;
  filters: InventaireFilters;
  matierePremiere: ModelViewInventaire;


  constructor(selectedStock: ModelViewInventaire, filters: InventaireFilters, matierePremiere: ModelViewInventaire) {
    this.selectedStock = selectedStock;
    this.filters = filters;
    this.matierePremiere = matierePremiere;
  }
}

export interface SiteInventaireDisponible {
  siteId: number;
  annee: number;
  mois: number;
  isSaved: boolean;
}

